import { notify, setUpNotifications } from "reapop";
import _ from "underscore";
import { GROUP_ACTIONS_FAILED, USER_IS_LOCKED } from "../utils/constants";

// run this function when your application starts before creating any notifications
setUpNotifications({
  defaultProps: {
    dismissible: false,
    dismissAfter: 4000,
    allowHTML: true,
    title: "Status",
    closeButton: false,
    position: "top-right",
  },
});

const fetchResolved = (payload) => {
  if (
    payload &&
    (payload.data === null || _.isUndefined(payload.data)) &&
    _.has(payload, "errors")
  ) {
    return false;
  }
  return true;
};
const isOflcAction = (actionType, payload) => {
  let oflc_action =
    actionType && actionType.includes("_") ? actionType.split("_") : false;
  if (!oflc_action && _.first(oflc_action) !== "OFLC") return false;
  let data = _.rest(oflc_action).join(" ");
  let message = null;
  let resolvedFetch = fetchResolved(payload);
  let gqlMessage = payload?.errors?.[0]?.message;

  if (resolvedFetch) {
    message = data.replace(/_/g, " ").replace(/\w\S*/g, function (d) {
      return d.charAt(0).toUpperCase() + d.substr(1).toLowerCase();
    });
  } else if (gqlMessage) {
    message = gqlMessage;
  } else {
    message = "Your request cannot be processed";
  }
  let _default = {
    oflc: true,
  };

  if (
    _.first(oflc_action) === "OFLC" &&
    _.last(oflc_action) === "SUCCESS" &&
    resolvedFetch
  ) {
    return {
      ..._default,
      message: `${message}`,
      status: "success",
    };
  } else if (
    (_.first(oflc_action) === "OFLC" && _.last(oflc_action) === "FAILURE") ||
    !resolvedFetch
  ) {
    return {
      ..._default,
      message: `${message}`,
      status: "error",
    };
  }
  return false;
};

const isGroupActionFailed = (action) => {
  const { type, payload } = action;
  const response = payload?.data?.[GROUP_ACTIONS_FAILED[type]];
  if (
    !!GROUP_ACTIONS_FAILED[type] &&
    (response === 403 || response === USER_IS_LOCKED)
  ) {
    return true;
  }
  return false;
};

const dispatchNotificaton = (action, store) => {
  const { dispatch } = store;
  let oflcAction = isOflcAction(action.type, action.payload);
  if (oflcAction && action.payload && !isGroupActionFailed(action)) {
    dispatch(
      notify({
        message: action.payload.message || oflcAction.message,
        status: action.payload.status || oflcAction.status,
      })
    );
  }

  if (isGroupActionFailed(action)) {
    dispatch(
      notify({
        message: action.lockedUserMessage,
        status: "error",
      })
    );
  }
};

export default (store) => (next) => (action) => {
  if (!action) return;
  next(action);
  dispatchNotificaton(action, store);
};
